import Header from "../src/Header.js";
import Player from "./Player.js";
import GameBoard from "./GameBoard.js";
import GameOver from "./GameOver.js";
import Log from "./Log.js";
import { useState } from "react";

import { WINNING_COMBINATIONS } from "./winning-combination.js";

const initalgb = [
  [null, null, null],
  [null, null, null],
  [null, null, null],
];

function deriveGameBoard(turns) {
  let gameBoard = [...initalgb.map((arr) => [...arr])];

  for (const turn of turns) {
    const { square, player } = turn;
    const { row, col } = square;

    gameBoard[row][col] = player;
  }

  return gameBoard;
}

function deriveWinner(gameBoard, players) {
  let winner;

  for (const combination of WINNING_COMBINATIONS) {
    const firstSquareSymbol =
      gameBoard[combination[0].row][combination[0].column];
    const secondSquareSymbol =
      gameBoard[combination[1].row][combination[1].column];
    const thirdSquareSymbol =
      gameBoard[combination[2].row][combination[2].column];

    if (
      firstSquareSymbol &&
      firstSquareSymbol === secondSquareSymbol &&
      firstSquareSymbol === thirdSquareSymbol
    ) {
      winner = players[firstSquareSymbol];
    }
  }

  return winner;
}

function App() {
  const [players, setPlayers] = useState({
    X: "Player 1",
    O: "Player 2",
  });

  const [activePlayer, setActivePlayer] = useState("X");
  const [turns, setGameTurns] = useState([]);
  const gameBoard = deriveGameBoard(turns);
  const winner = deriveWinner(gameBoard, players);
  const hasDraw = turns.length === 9 && !winner;

  function handleSelectSquare(rowIndex, colIndex) {
    setActivePlayer((activePlayer) => (activePlayer === "X" ? "O" : "X"));
    setGameTurns((prevTurns) => {
      let currenPlayer = "X";

      if (prevTurns.length > 0 && prevTurns[0].player === "X") {
        currenPlayer = "O";
      }

      const updatedTurns = [
        { square: { row: rowIndex, col: colIndex }, player: currenPlayer },
        ...prevTurns,
      ];

      return updatedTurns;
    });
  }

  function handleRestart() {
    setGameTurns([]);
  }

  function handlePlayerNameChange(symbol, newName) {
    setPlayers((prevPlayers) => {
      return { ...prevPlayers, [symbol]: newName };
    });
  }
  return (
    <>
      <Header></Header>
      <main>
        <div id="game-container">
          <ol id="players" className="highlight-player">
            <Player
              initialName="Player 1"
              symbol="X"
              isActive={activePlayer === "X"}
              onChangeName={handlePlayerNameChange}
            ></Player>
            <Player
              initialName="Player 2"
              symbol="O"
              isActive={activePlayer === "O"}
              onChangeName={handlePlayerNameChange}
            ></Player>
          </ol>
          {(winner || hasDraw) && (
            <GameOver winner={winner} onRestart={handleRestart} />
          )}
          <GameBoard
            board={gameBoard}
            onSelectSquare={handleSelectSquare}
          ></GameBoard>
        </div>
        <Log turns={turns}></Log>
      </main>
    </>
  );
}

export default App;
